import { TitleWrap, Title, Text } from '@/vdp/AlertModal';
import { useDDAddAction } from '~/hooks/common/telemetry';
import AlertIcon from './AlertIcon';

const NotAvailableInCA = () => {
  useDDAddAction('Not available in this State - Banner Shown');

  return (
    <>
      <TitleWrap>
        <AlertIcon />
        <Title data-qa="not-available-in-state">
          Not available in this State
        </Title>
      </TitleWrap>
      <Text>
        Unfortunately, we are unable to verify if this vehicle is California
        Emissions compliant, so we are unable to sell this vehicle to California
        residents.
      </Text>
    </>
  );
};

export default NotAvailableInCA;
